import { render, staticRenderFns } from "./floatingStrip.vue?vue&type=template&id=2adc5a56&scoped=true&"
import script from "./floatingStrip.vue?vue&type=script&lang=js&"
export * from "./floatingStrip.vue?vue&type=script&lang=js&"
import style0 from "./floatingStrip.vue?vue&type=style&index=0&id=2adc5a56&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2adc5a56",
  null
  
)

export default component.exports